<template>
    <v-dialog v-model="visible" persistent max-width="900px" scrollable>
        <v-card :loading="loading">
            <v-card-title>
                <span class="headline">{{ $t('modal.editComplianceSettings.title') }}</span>
            </v-card-title>
            <v-card-text>
                <p class="text-h6">Data Sets</p>
                <p class="subtitle-2">Configure which sanction jurisdictions and other data sets are used for case screening.</p>

                <v-row class="ml-6 subtitle-1" no-gutters>
                    <v-col>
                        <p>Americas</p>
                    </v-col>
                </v-row>

                <v-row class="ml-10" no-gutters>
                    <v-col>
                        <!-- SDN -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">OFAC SDN</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="SDN"
                                    multiple dense /></v-col>
                        </v-row>
                        <!-- NONSDN -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">OFAC Non SDN</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="NONSDN"
                                    multiple dense /></v-col>
                        </v-row>
                        <!-- DPL -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">US Bureau of Industry and Security - DPL</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="DPL"
                                    multiple dense /></v-col>
                        </v-row>
                        <!-- UN -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">United Nations Security Counsil</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="UN"
                                    multiple dense /></v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="ml-6 subtitle-1" no-gutters>
                    <v-col>
                        <p>Europe</p>
                    </v-col>
                </v-row>
                <v-row class="ml-10" no-gutters>
                    <v-col>
                        <!-- EU -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">EU Financial Sanctions Files - FSF</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="EU"
                                    multiple dense /></v-col>
                        </v-row>
                        <!-- UK -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">UK OFSI Consolidated List</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="UK"
                                    multiple dense /></v-col>
                        </v-row>
                        <!-- Aus -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">Australian Sanctions - DFAT</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="DFAT"
                                    multiple dense /></v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row class="ml-6 subtitle-1" no-gutters>
                    <v-col>
                        <p>Others</p>
                    </v-col>
                </v-row>
                <v-row class="ml-10" no-gutters>
                    <v-col>
                        <!-- PEP -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">PEP</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="PEP"
                                    multiple dense /></v-col>
                        </v-row>
                        <!-- Crypto -->
                        <v-row no-gutters align="center">
                            <v-col cols="4">Digital Wallet (Crypto)</v-col>
                            <v-col><v-switch class="pa-0 ma-0" v-model="editAccount.accountSettings.lists" value="CRYPTO"
                                    multiple dense /></v-col>
                        </v-row>

                        <!-- TODO add SAM, FHA, etc -->
                    </v-col>
                </v-row>

            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" text @click="onCancel">{{ $t('label.cancel') }}</v-btn>
                <v-btn color="blue darken-1" dark @click="handleSubmit" :loading="loading">{{ $t('label.save')
                }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
  
<script>
import { mapActions } from "vuex";
export default {
    name: "EditComplianceSources",
    data() {
        return {
            loading: false,
            editAccount: {
                ...this.account,
                accountSettings: this.account.accountSettings ? this.account.accountSettings : {}
            }
        };
    },
    props: {
        account: {},
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        account: {
            immediate: true,
            handler(val) {
                this.editAccount = {
                    ...val,
                    accountSettings: val.accountSettings ? val.accountSettings : {}
                }
            }
        }
    },
    methods: {
        ...mapActions([
            "updateAccount", "setGlobalAlert"
        ]),
        handleSubmit() {
            this.loading = true;
            this.updateAccount(this.editAccount)
                .then(() => {
                    this.setGlobalAlert({
                        alert: true,
                        color: "green",
                        alertMessage: "Compliance Settings Updated",
                    });
                    this.$emit("onCancelled");
                })
                .catch((err) => {
                    console.log("updateAccount.settings error", err)
                    this.setGlobalAlert({
                        alert: true,
                        color: "red",
                        alertMessage: this.$t("error.general.unhandled"),
                    });
                })
                .finally(() => {
                    this.loading = false;
                });

        },
        onCancel() {
            this.loading = false;
            this.$emit("onCancelled");
        }
    },
    created: function () {
    }
};
</script>